import { createFetcher } from '../contexts/Fetcher';
import { apiOrganization } from '../resources/api/apiOrganization';
import { useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { useParams } from 'react-router-dom';
import { pending } from '../helpers/pending';

const { useGetUser } = apiOrganization;

export const OrganizationUserFetcher = createFetcher(() => {
  const { user_id } = useParams<{ user_id: string }>();
  const { organization } = useContext(OrganizationContext);

  const { execute } = useGetUser(organization?.name, user_id);

  return organization ? execute : pending;
});
